// MarketPage.js
import React from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import Carousel from "./Carousel";
import ProductCard from "./ProductCard";
import TopMarketPlace from "./TopMarketPlace";
import ProductTabs from "./ProductTabs";

const product = {
  image:
    "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
  title: "Adidas 4D X Parley Running Shoes",
  oldPrice: 444.0,
  price: 333.2,
  discount: 12,
};

const MarketPage = () => {
  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />
      <main className="flex-1 p-6 pl-8 overflow-x-hidden">
        <LeftResponsivesidebar />
        <Headmenu />

        {/* Carousel and Product cards section */}
        <div className="">
          <Carousel />
          <ProductCard />
          <TopMarketPlace />
          <ProductTabs />
        </div>
      </main>
    </div>
  );
};

export default MarketPage;
